import { ILocalStorageService } from "./ILocalStorageService";
import { DependencyContainer } from "../DependencyContainer";
import { Api } from "../Api";

export class LocalStorageService implements ILocalStorageService {
    public static readonly ServiceName: string = "LocalStorageService";

    GetServiceName(): string {
        return LocalStorageService.ServiceName;
    }

    private GetResourceName(inContextOf: string, objectId: string): string {
        return `_exalus_${Api.WorksInContextOf}_${inContextOf}_${objectId}`;
    }

    Remove(inContextOf: string, objectId: string): void {
        localStorage.removeItem(this.GetResourceName(inContextOf, objectId));
    }

    DropStorage(inContextOf: string): void {
        const prefix = `_exalus_${Api.WorksInContextOf}_${inContextOf}`;
        const keysToRemove = Object.keys(localStorage).filter(k => k.startsWith(prefix));

        keysToRemove.forEach(k => {
            DependencyContainer.Log?.Warning(LocalStorageService.ServiceName, `Clearing API cache for key: ${k}`);
            localStorage.removeItem(k);
        });
    }

    Save(inContextOf: string, objectId: string, data: any): void {
        localStorage.setItem(this.GetResourceName(inContextOf, objectId), JSON.stringify(data));
    }

    Read<T>(inContextOf: string, objectId: string): T | null {
        try {
            let name = this.GetResourceName(inContextOf, objectId);
            let obj = localStorage.getItem(name);

            if (obj == null)
                return null;

            return JSON.parse(obj) as T;
        }
        catch (ex: any) {
            DependencyContainer.Log?.Error(LocalStorageService.ServiceName, `Exception has occurred while reading ${this.GetResourceName(inContextOf, objectId)}`);
            return null;
        }
    }
}